module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// /Users/andrewkahn/.nvm/versions/node/v6.10.1/lib/~/vue-cli/~/core-js/library/modules/_add-to-unscopables.js
// module id = 55
// module chunks = 0